// extracted by mini-css-extract-plugin
module.exports = {"container":"LicensingView_container__ieNL3","headerText":"LicensingView_headerText__2L-Vv"};